import { AlertTriangle, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/Button";

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
  /** Next.js error digest — the only handle support has on a server-side failure. */
  digest?: string;
}

export function ErrorState({
  title = "Bir hata oluştu",
  message,
  onRetry,
  retryLabel = "Tekrar Dene",
  digest,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-12 text-center">
      <div className="grid h-[46px] w-[46px] place-items-center rounded-[13px] border border-error-glow-20 bg-error-glow-12 text-error-light">
        <AlertTriangle className="h-5 w-5" aria-hidden />
      </div>
      <h3 className="mt-4 font-display text-lg font-semibold tracking-[-0.02em] text-foreground">
        {title}
      </h3>
      <p className="mt-2 max-w-[340px] text-sm leading-[1.6] text-muted-foreground">
        {message}
      </p>
      {onRetry && (
        <Button
          onClick={onRetry}
          variant="secondary"
          leftIcon={RotateCcw}
          className="mt-5"
        >
          {retryLabel}
        </Button>
      )}
      {digest && (
        <p className="mt-5 font-mono text-[11px] tracking-[0.06em] text-[var(--color-text-disabled)]">
          #{digest}
        </p>
      )}
    </div>
  );
}
